import React from "react";
import { Checkbox, FormControlLabel } from "@mui/material";
import CField, { CFieldInputProps } from "$forms/CField";
import { useUserFormContext } from "../context/UserFormContext";
import { useStyles } from "./styles";

export const UserFormAccess: React.FC = () => {
  const { form, canBeUser, hasToBeUser } = useUserFormContext();
  const {
    control,
    watch,
    setValue,
    formState: { errors },
  } = form;
  const classes = useStyles();

  if ((!canBeUser && watch("isOnlyContact")) || hasToBeUser) {
    return null;
  }

  const isUserOfPlatform = !watch("isOnlyContact");

  const handleUserCheckboxChange = (event: any, checked: boolean) => {
    if (checked) {
      setValue("isApprover", false, {
        shouldDirty: true,
        shouldValidate: true,
      });
    }
  };

  return (
    <div className={classes.fieldsColumn}>
      <CField
        control={control}
        name="isOnlyContact"
        error={errors.isOnlyContact}
        label="Le contact doit être utilisateur de la plateforme"
      >
        {(props: CFieldInputProps) => (
          <FormControlLabel
            control={
              <Checkbox
                {...props}
                color="primary"
                onChange={(event, checked) => {
                  props.onChange(!checked);
                  handleUserCheckboxChange(event, !checked);
                }}
                checked={!props.value}
              />
            }
            label={props.label}
          />
        )}
      </CField>

      {isUserOfPlatform && (
        <CField
          control={control}
          name="isApprover"
          error={errors.isApprover}
          label="L’utilisateur est approbateur des EDB"
        >
          {(props: CFieldInputProps) => (
            <FormControlLabel
              control={
                <Checkbox
                  {...props}
                  color="primary"
                  checked={props.value || false}
                  onChange={(event, checked) => {
                    props.onChange(checked);
                  }}
                />
              }
              label={props.label}
            />
          )}
        </CField>
      )}
    </div>
  );
};
